import { TrackNode } from "./TrackNode";
export class TrackPipeline {
    input;
    output;
    processNodes = [];
    constructor(input) {
        this.input = new TrackNode(input);
    }
    build(plugins) {
        let lastNode = this.input;
        plugins.forEach((p) => {
            const node = new TrackNode(p);
            this.processNodes.push(node);
            node.connectToInput(lastNode);
            lastNode = node;
        });
        this.output = lastNode;
        return () => this.clear();
    }
    clear() {
        this.processNodes.forEach((p) => {
            p.stop();
        });
        this.processNodes = [];
        this.output = undefined;
    }
    debugInfo() {
        return {
            input: this.input.debugInfo(),
            pipeline: this.processNodes.map((n) => n.debugInfo()),
        };
    }
}
//# sourceMappingURL=TrackPipeline.js.map